import { TimePickerHelpers } from '@percent/domain/giving'

export const parseTimeToHoursMinutes = (time?: string): { hours: number; minutes: number } | null => {
  if (!time) return null
  const formatted = TimePickerHelpers.formatTime(time, false)
  const match = formatted.match(/^(\d{2}):(\d{2})$/)

  if (!match) return null

  return { hours: parseInt(match[1], 10), minutes: parseInt(match[2], 10) }
}
